import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCore } from "@obg/core.config";
import { ConfigService } from "@obg/ngx.global";

const API_URLS = Object.freeze({
	agreementsApiUrlV1Accept: "v1/agreements/accept",
});

@Injectable({
	providedIn: "root",
})
export class CustomerManagementConfigService {
	constructor(private configService: ConfigService<ObgConfigFeAdaptiveClientCore>) {}

	/**
	 * this configuration requires Jurisdiction
	 */
	getCustomerEndpoint(): string {
		return this.configService.get(
			(x) => x.core.customerManagement.endpoints!.currentCustomer,
			"v2/currentcustomer/:section"
		);
	}

	getVerifyTokenEndpoint(): string {
		return this.configService.get(
			(x) => x.core.customerManagement.endpoints!.verifyToken,
			"v1/currentcustomerverification/:token"
		);
	}

	getEmailAvailabilityEndpoint(): string {
		return this.configService.get(
			(x) => x.core.customerManagement.endpoints!.emailAvailability,
			"v1/customeremails/:email/"
		);
	}

	getUnsubscribeFromNewsletterEndpoint(): string {
		return this.configService.get(
			(x) => x.core.customerManagement.endpoints!.unsubscribeFromNewsletter,
			"v1/newslettersubscription/:token"
		);
	}

	getTermsAndConditionsEndpoint(): string {
		return this.configService.get(
			(x) => x.core.customerManagement.endpoints!.termsAndConditions,
			"v1/termsandconditionstoken"
		);
	}

	getDeclineTermsAndConditionsEndpoint(): string {
		return this.configService.get(
			(x) => x.core.customerManagement.endpoints!.termsAndConditions,
			"v1/termsandconditionstoken"
		);
	}

	getAcceptTermsAndConditionsEndpoint(): string {
		return this.configService.get(
			(x) => x.core.customerManagement.endpoints!.acceptTermsAndConditions,
			API_URLS.agreementsApiUrlV1Accept
		);
	}

	getAcceptPrivacyPolicyEndpoint(): string {
		return this.configService.get(
			(x) => x.core.customerManagement.endpoints!.acceptPrivacyPolicy,
			API_URLS.agreementsApiUrlV1Accept
		);
	}

	getAcceptEntityLegalNoticeEndpoint(): string {
		return this.configService.get(
			(x) => x.core.customerManagement.endpoints!.acceptEntityLegalNotice,
			API_URLS.agreementsApiUrlV1Accept
		);
	}

	getProfileValidationEndpoint(): string {
		return this.configService.get(
			(x) => x.core.customerManagement.endpoints!.profileValidation,
			"v2/currentcustomer/profilevalidations"
		);
	}

	getProfileConfirmationEndpoint(countryCode?: string): string {
		return countryCode
			? this.configService.get((x) => x.core.customerManagement.endpoints!.profileConfirmation, {})[countryCode]
			: "v2/coga/currentcustomer/profileconfirmations";
	}

	getIsCensorshipEnabled(): boolean {
		return this.configService.get((x) => x.core.customerManagement.censorship!.enabled, false);
	}
}
